import React from 'react'

export default function Product() {

    return (
        <div style={{marginBottom:'50%'}}>
            Product page
        </div>
    )
}